import { render, staticRenderFns } from "./AlertsDashboardTemplate.vue?vue&type=template&id=659a373c&"
import script from "./AlertsDashboardTemplate.vue?vue&type=script&lang=js&"
export * from "./AlertsDashboardTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AlertsDashboardTemplate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports